// Automatically generated from TW.Saga.Core.Base, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @13.12.2018 15:04:15
import { RbacProfile_abstract } from './../../abstract/SagaBase/RBAC/RbacProfile_abstract';
export class RbacProfile extends RbacProfile_abstract {}
